import { isProduction } from '@libs/environment';
import { Themes } from '@layouts/main-layout/themes.enum';
import { Dispatch, FC, SetStateAction, SVGProps } from 'react';
import type { ComponentType } from 'react';
import BuyPreview from './nav-previews/buy-preview/buy-preview';
import BuyMobilePreview from './nav-previews/buy-mobile-preview/buy-mobile-preview';
import ProductsPreview from './nav-previews/products-preview/products-preview';
import SolutionsPreview from './nav-previews/solutions-preview/solutions-preview';
import ResourcesPreview from './nav-previews/resources-preview/resources-preview';
import SimpleMobilePreview from './nav-previews/simple-mobile-preview/simple-mobile-preview';
import { ProductsPreviewState } from '../nav-state/products-preview.state';
import { SolutionsPreviewState } from '../nav-state/solutions-preview.state';
import { ResourcesPreviewState } from '../nav-state/resources-preview.state';
import UserHeadsetIcon from 'public/layout-images/header/resources-preview/user-headset-20.svg';
export const ARROW_ICON = '/assets/icons/icn-arrow.svg';

type HeaderState = {
  logo: string;
  darkModeLogo: string;
  logoMobile: string;
  darkModeLogoMobile: string;
  navigation: HeaderNavigation[];
};

export type HeaderNavigation = {
  name: string;
  link: string;
  newTab?: boolean;
  activePaths?: string[];
  preview?: (theme: Themes, setViewingLink?: Dispatch<SetStateAction<string>>) => JSX.Element;
  burgerPreview?: (theme: Themes, onMenuClicked: () => void) => JSX.Element;
  actionButton?: boolean;
  Icon?: ComponentType<SVGProps<SVGSVGElement>>;
};

const productsItems = ProductsPreviewState.columns.flatMap((column) => column.cards);
const solutionsItems = SolutionsPreviewState.columns.flatMap((column) => column.cards);
const resourcesItems = ResourcesPreviewState.columns.flatMap((column) => column.cards);

export const HeaderState: HeaderState = {
  logo: `/assets/header/logo/gofinans-logo.svg`,
  darkModeLogo: '/assets/header/logo/gofinans-logo.svg',
  logoMobile: `/assets/header/logo/gofinans-logo-mobile.svg`,
  darkModeLogoMobile: '/assets/header/logo/gofinans-logo-mobile.svg',
  navigation: [
    {
      name: `Buy.Nav.Title`,
      link: `/buy-crypto`,
      activePaths: ['/buy-crypto', '/sell-buy-crypto'],
      preview: (theme: Themes) => <BuyPreview theme={theme} />,
      burgerPreview: (theme: Themes, onMenuClicked: () => void) => <BuyMobilePreview theme={theme} onMenuClicked={onMenuClicked}/>,
    },
    {
      name: `Products.Nav.Title`,
      link: `/products`,
      preview: (theme: Themes) => <ProductsPreview theme={theme} />,
      burgerPreview: (theme: Themes, onMenuClicked: () => void) => <SimpleMobilePreview theme={theme} cards={productsItems} onMenuClicked={onMenuClicked}/>,
    },
    {
      name: `Solutions.Nav.Title`,
      link: `/solutions`,
      preview: (theme: Themes) => <SolutionsPreview theme={theme} />,
      burgerPreview: (theme: Themes, onMenuClicked: () => void) => <SimpleMobilePreview theme={theme} cards={solutionsItems} onMenuClicked={onMenuClicked}/>,
    },
    {
      name: `Resouces.Nav.Title`,
      link: `/blog`,
      preview: (theme: Themes) => <ResourcesPreview theme={theme} />,
      burgerPreview: (theme: Themes, onMenuClicked: () => void) => <SimpleMobilePreview theme={theme} cards={resourcesItems} onMenuClicked={onMenuClicked}/>,
    },
    {
      name: `Resources.Nav.Talk_to_sales`,
      link: `/contact-us`,
      actionButton: true,
      Icon: UserHeadsetIcon,
    },
  ],
};
